<template>
  <figure class="image" :class="`is-${size}x${size}`">
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="152 -62.7 916.7 916.7"
      xml:space="preserve"
    >
      <path
        d="M616.6,91.6c-167.8,0-303.8,136-303.8,303.8s136,303.8,303.8,303.8s303.8-136,303.8-303.8 C920.3,227.7,784.3,91.6,616.6,91.6 M731.7,288.5c-35.8-35.8-85-52.1-135.2-44.4c-70.9,10.7-126,70-132,141.5 c-7.7,92.9,65.5,170.2,156.2,170.2c28.8,0,55.9-7.8,79.1-21.4c0,0,0.7,30.9-2.1,37.7c-23.5,10.5-49.6,16.4-77,16.4 c-108.2,0-195.9-91.4-189-201.6c6-94.6,83.6-171.2,178.2-176.3c54.5-3,106,16.6,144.4,54.9L731.7,288.5z M556.2,463.6 c15.4,16,39.8,19.6,62,20.1l-0.6,30.6c-30.2-0.9-62.2-7.5-83.4-29.5c-21.1-22-32.5-50.8-31.9-80.7c0.6-30.6,13-59,35-80.1 c21.6-20.8,50.4-32.1,81-31.5l-0.9,30.3c-22.3-0.4-42.9,7.9-58.9,23.3c-16.3,15.7-25.4,36-25.9,58.3 C532.2,426.6,540.9,447.6,556.2,463.6"
      />
      <polygon
        class="fl-green"
        points="640.3,409.2 747.7,409.2 747.7,538.6 779.4,515.7 779.4,383.6 640.3,383.6 "
      />
    </svg>
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="152 -62.7 916.7 916.7"
      xml:space="preserve"
    >
      <path
        class="fl-green"
        d="M942.2,95.5c0,12.8-10.4,23.2-23.2,23.2s-23.2-10.4-23.2-23.2s10.4-23.2,23.2-23.2 S942.2,82.7,942.2,95.5"
      />
      <path
        d="M347.1,699.5c0,17.8-14.4,32.2-32.2,32.2c-17.8,0-32.2-14.5-32.2-32.2c0-17.8,14.4-32.3,32.2-32.3 C332.7,667.2,347.1,681.7,347.1,699.5"
      />
    </svg>
  </figure>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: "32",
      validator(size) {
        return ["16", "32", "64", "128"].indexOf(size) !== -1;
      }
    }
  }
};
</script>

<style lang="scss">
figure.image {
  margin: 0 auto;
  position: relative;

  svg:last-of-type {
    position: absolute;
    top: 0;
    left: 0;
    transform-origin: center;
    transition: 2s;
    transition-timing-function: ease;
  }
  &:hover svg:last-of-type {
    transform: rotate(720deg);
  }
}
</style>
